import { Card, CardBody } from '@heroui/react';

import type { KreatliCapability } from '../../data/kreatli-capabilities';
import { Icon } from '../various/Icon';

interface CapabilityGridProps {
  id: string;
  title: string;
  description?: string;
  capabilities: KreatliCapability[];
}

/** Grid of verified Kreatli capabilities (build the list with `getKreatliCapabilities`). */
export function CapabilityGrid({ id, title, description, capabilities }: CapabilityGridProps) {
  return (
    <section className="relative overflow-hidden px-6 py-16 backdrop-blur-lg" aria-labelledby={id}>
      <div className="relative z-10 mx-auto max-w-6xl">
        <div className="mb-8 text-center">
          <h2 id={id} className="mb-4 font-sans text-2xl font-bold sm:text-3xl">
            {title}
          </h2>
          {description ? <p className="mx-auto max-w-2xl text-lg text-foreground-500">{description}</p> : null}
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {capabilities.map((capability) => (
            <Card key={capability.title} className="border border-foreground-200 bg-content1/60 backdrop-blur-lg">
              <CardBody className="p-6">
                <div className="mb-4 flex items-center gap-3">
                  <div className="rounded-full bg-foreground-100 p-2">
                    <Icon icon={capability.icon} size={20} className="text-primary" />
                  </div>
                  <h3 className="font-sans text-lg font-semibold">{capability.title}</h3>
                </div>
                <p className="text-sm text-foreground-500">{capability.description}</p>
              </CardBody>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
